import { Airline, LayoverAirport } from 'components/CrewChangePanel/types';

export const isAllSelected = (itemArray: (LayoverAirport | Airline)[]) =>
  itemArray.every(({ selected }) => selected);

export const isAllDeselected = (itemArray: (LayoverAirport | Airline)[]) =>
  itemArray.every(({ selected }) => !selected);
